export default __webpack_public_path__ + "images/GDE.2d4fde6.png";